// extracted by mini-css-extract-plugin
export var downArrow = "_b9-0";
export var label = "_b9-1";
export var treatmentCard = "_b9-3";
export var upArrow = "_b9-2";